import React, { useRef } from "react";
import cx from "classnames";
import { Link } from "@inertiajs/inertia-react";
import { UserCircleIcon } from "@heroicons/react/solid";

export default ({ name, className, errors = [], ...props }) => {
    const textAreaRef = useRef();

    function insertTextAtCursor(el, text) {
        var val = el.value,
            endIndex,
            range,
            doc = el.ownerDocument;
        if (
            typeof el.selectionStart == "number" &&
            typeof el.selectionEnd == "number"
        ) {
            endIndex = el.selectionEnd;
            el.value = val.slice(0, endIndex) + text + val.slice(endIndex);
            el.selectionStart = el.selectionEnd = endIndex + text.length;
        } else if (doc.selection != "undefined" && doc.selection.createRange) {
            el.focus();
            range = doc.selection.createRange();
            range.collapse(false);
            range.text = text;
            range.select();
        }
    }

    function handleFeeClick(e) {
        e.preventDefault();
        insertTextAtCursor(textAreaRef.current, "{{net_total}}");
    }

    function handleFeeDetail(e) {
        e.preventDefault();
        insertTextAtCursor(textAreaRef.current, "{{fee_detail}}");
    }

    function handleStudentFullName(e) {
        e.preventDefault();
        insertTextAtCursor(textAreaRef.current, "{{student_name:full}}");
    }

    return (
        <div className={"relative"}>
            <div className="mt-1">
                <textarea
                    ref={textAreaRef}
                    rows={6}
                    name={name}
                    className={cx(
                        "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                        {
                            "border-red-300": errors.length,
                        },
                        className
                    )}
                    {...props}
                />
                <div aria-hidden="true">
                    <div className="py-2">
                        <div className="h-9" />
                    </div>
                </div>
            </div>
            <div className="absolute inset-x-px bottom-0">
                {/* Actions: These are just examples to demonstrate the concept, replace/wire these up however makes sense for your project. */}
                <div className="flex flex-nowrap justify-end space-x-2 py-2 px-2 sm:px-3">
                    <div className="flex-shrink-0">
                        <div className="relative">
                            <Link
                                onClick={handleFeeClick}
                                className={
                                    "relative inline-flex items-center space-x-1 whitespace-nowrap rounded-full bg-gray-50 py-2 px-2 text-sm font-medium text-gray-500 hover:bg-gray-100 sm:px-3"
                                }
                            >
                                <UserCircleIcon
                                    className="h-5 w-5 flex-shrink-0 text-gray-300 sm:-ml-1"
                                    aria-hidden="true"
                                />
                                <span>Fee Total</span>
                            </Link>
                            <Link
                                onClick={handleFeeDetail}
                                className={
                                    "relative inline-flex items-center space-x-1 whitespace-nowrap rounded-full bg-gray-50 py-2 px-2 text-sm font-medium text-gray-500 hover:bg-gray-100 sm:px-3"
                                }
                            >
                                <UserCircleIcon
                                    className="h-5 w-5 flex-shrink-0 text-gray-300 sm:-ml-1"
                                    aria-hidden="true"
                                />
                                <span>Fee Detail</span>
                            </Link>
                            <Link
                                onClick={handleStudentFullName}
                                className={
                                    "relative inline-flex items-center space-x-1 whitespace-nowrap rounded-full bg-gray-50 py-2 px-2 text-sm font-medium text-gray-500 hover:bg-gray-100 sm:px-3"
                                }
                            >
                                <UserCircleIcon
                                    className="h-5 w-5 flex-shrink-0 text-gray-300 sm:-ml-1"
                                    aria-hidden="true"
                                />
                                <span>Full Name</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {errors && <p className="mt-2 text-sm text-red-600">{errors}</p>}
        </div>
    );
};
